// evolucao.component.ts
import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { MarcacaoModel } from "../../models/marcacao.model";
import { SharedMarcacaoService } from "../../services/shared-marcacao.service";
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PrintService } from "../../services/print.service";
import { ToastrService } from "ngx-toastr";
import { MedicoService } from "../../services/medico.service";
import { MedicoModel } from 'src/app/models/medico.model';
import { MarcacaoService } from 'src/app/services/marcacao.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-evolucao',
  templateUrl: './evolucao.component.html',
  styleUrls: ['./evolucao.component.scss']
})
export class EvolucaoComponent implements OnInit {
  protected marcacaoAtual: MarcacaoModel;
  protected relatorio_Profissional_SafeHtml: SafeHtml | null = null;
  protected evolucaoCopiada: string = '';
  protected medicos: MedicoModel[] = [];
  private subscricoes = new Subscription();
  @ViewChild('editorArea') editorArea!: ElementRef;
  private selecaoSalva: Range | null = null;


  constructor(private sharedMarcacaoService: SharedMarcacaoService,
    private printService: PrintService, private sanitizer: DomSanitizer,
    private toastrService: ToastrService,
    private medicoService: MedicoService,
    private marcacaoService: MarcacaoService,
  ) {
    this.marcacaoAtual = new MarcacaoModel();
  }

  ngOnInit() {
    this.subscricoes.add(this.sharedMarcacaoService.marcacaoAtual.subscribe((res) => {
      const EM_ATENDIMENTO = 5;
      this.marcacaoAtual = res ?? new MarcacaoModel();
      if (this.marcacaoAtual.status_Atendimento === EM_ATENDIMENTO) {
        if (this.marcacaoAtual?.seq_Beneficiario && this.marcacaoAtual?.seq_Setor) {
          this.carregarUltimaEvolucao();
        }
      } else if (this.marcacaoAtual.relatorio_Profissional) {
        this.relatorio_Profissional_SafeHtml =
          this.sanitizer.bypassSecurityTrustHtml(this.marcacaoAtual.relatorio_Profissional);
      } else {
        this.relatorio_Profissional_SafeHtml = null;
      }

      if (this.marcacaoAtual?.seq_Setor) {
        this.carregarMedicos(this.marcacaoAtual.seq_Setor, 'A');
      }

    }));
    this.subscricoes.add(
    this.sharedMarcacaoService.evolucaoCopiada.subscribe((evolucao) => {
      this.evolucaoCopiada = evolucao;
    }));
  }

  imprimir() {
    const medico = this.marcacaoAtual.corpoClinico?.profissional;
    const listaHtml = this.geraHtmlMedicos(this.medicos);

    const medicoNome = medico?.nome;
    const numConselho = medico?.num_Conselho;

    const medicos = `
    ${listaHtml}
      <div style="padding-left: 240px; font-size: 11px; line-height: 1.4;">
      ${this.marcacaoAtual.relatorio_Profissional ?? ''}
    </div>
  `;

    this.printService.printHtmlString('Evolução', this.marcacaoAtual.beneficiario?.nome_Beneficiario,
      medicos, medico, numConselho);
  }

  public copiarEvolucao() {
    const REALIZADO = 6;
    const FINALIZADO = 7;

    if ((this.marcacaoAtual.status_Atendimento === FINALIZADO || this.marcacaoAtual.status_Atendimento === REALIZADO) && this.marcacaoAtual.relatorio_Profissional) {

      this.sharedMarcacaoService.setEvolucaoCopiada(this.marcacaoAtual.relatorio_Profissional);
      this.toastrService.success('Evolução copiada com sucesso!', 'Copiado');

    } else {
      this.toastrService.warning('Este botão só pode ser usado em atendimentos FINALIZADOS que contenham evolução.', 'Atenção');
    }
  }

  public colarEvolucao() {
    const EM_ATENDIMENTO = 5;

    if (this.evolucaoCopiada && this.marcacaoAtual.status_Atendimento === EM_ATENDIMENTO) {

      this.marcacaoAtual.relatorio_Profissional =
        (this.marcacaoAtual.relatorio_Profissional || '') + this.evolucaoCopiada;

      this.relatorio_Profissional_SafeHtml =
        this.sanitizer.bypassSecurityTrustHtml(this.marcacaoAtual.relatorio_Profissional);

      this.toastrService.success('Evolução anterior colada com sucesso!', 'Sucesso');

      this.sharedMarcacaoService.setEvolucaoCopiada('');

    } else {
      this.toastrService.warning('O botão Colar só está habilitado para o atendimento com status igual à EM ATENDIMENTO.', 'Atenção');
    }
  }

  public format(command: string) {
    document.execCommand(command, false, '');
  }

  public salvarSelecao() {
    const selecao = window.getSelection();
    if (selecao && selecao.rangeCount > 0) {
      this.selecaoSalva = selecao.getRangeAt(0);
    }
  }

  // 2. Restaura o texto selecionado
  private restaurarSelecao() {
    if (this.selecaoSalva) {
      const selecao = window.getSelection();
      selecao?.removeAllRanges();
      selecao?.addRange(this.selecaoSalva);
    }
  }

  private atualizarModeloManual() {
    if (this.editorArea) {
      // Pega o HTML modificado pelo execCommand
      const htmlModificado = this.editorArea.nativeElement.innerHTML;
      
      // Atualiza a variável que efetivamente vai para o banco de dados
      this.marcacaoAtual.relatorio_Profissional = htmlModificado;
      
      // Se a sua tela depender do SafeHtml para exibir imediatamente, atualize-o também:
      // this.relatorio_Profissional_SafeHtml = this.sanitizer.bypassSecurityTrustHtml(htmlModificado);
    }
  }

  public setColor(event: any) {
    const color = event.target.value;
    document.execCommand('foreColor', false, color);
  }  

  public setBackground(event: any) {
    const color = event.target.value;
    document.execCommand('hiliteColor', false, color);
  }

  carregarMedicos(seqSetor: number, status: string) {
    this.medicoService.getMedicos(seqSetor, status).subscribe({
      next: (res) => {
        if (!res.success) {
          return;
        }

        this.medicos = (res.data ?? []).flat();

      },
      error: (err) => {
        this.toastrService.error("Erro ao buscar médicos:", err);
      }
    });
  }

  geraHtmlMedicos(medicos: MedicoModel[]): string {
    if (!medicos || medicos.length === 0) return '';

    const itens = medicos.map(m => `
      <div style="margin-bottom: 6px;">
        <div style="font-weight: bold; font-size: 11px; color: #1a7f2e;">
          ${m.nome ?? ''}
        </div>
        <div style="font-weight: bold; font-size: 11px; color: #1a7f2e;">
          ${m.descricao_Especialidade ?? ''}
        </div>
      </div>
  `).join('');

    return `
    <div id="listaMedicos" style="
      position: fixed;
      top: 140px;
      left: 20px;
      width: 200px;
      height: auto;
    ">
      ${itens}
    </div>
  `;
  }


  private carregarUltimaEvolucao() {
    const seqBeneficiario = this.marcacaoAtual.seq_Beneficiario!;
    const seqClinicaAtual = this.marcacaoAtual.seq_Clinica!;
    const EM_ATENDIMENTO = 5;

    if (
      this.marcacaoAtual.status_Atendimento !== EM_ATENDIMENTO ||
      this.marcacaoAtual.relatorio_Profissional
    ) {
      return;
    }

    this.marcacaoService.getAllRealizadasBySeqBeneficiario(seqBeneficiario).subscribe({
      next: (res) => {
        if (!res.success || !Array.isArray(res.data)) return;

        const todas = res.data.map(m => Object.assign(new MarcacaoModel(), m));

        let evolucoesMesmaClinica = todas.filter(m =>
          m.seq_Clinica === seqClinicaAtual &&
          m.status_Atendimento !== EM_ATENDIMENTO &&
          m.relatorio_Profissional &&
          m.relatorio_Profissional.trim().length > 0
        );        

        if (evolucoesMesmaClinica.length === 0) {
          this.toastrService.info(
            "Nenhuma evolução anterior encontrada para esta especialidade.",
            "Informação"
          );
          return;
        }

        evolucoesMesmaClinica.forEach(e => {
          const dt = new Date(e.data_Agenda);
          dt.setHours(Math.floor(e.hora_Agenda / 100));
          dt.setMinutes(e.hora_Agenda % 100);
          (e as any).dataCompleta = dt.getTime();
        });

        evolucoesMesmaClinica.sort(
          (a, b) => (b as any).dataCompleta - (a as any).dataCompleta
        );

        const ultima = evolucoesMesmaClinica[0];        

        this.marcacaoAtual.relatorio_Profissional = ultima.relatorio_Profissional;

        this.relatorio_Profissional_SafeHtml =
          this.sanitizer.bypassSecurityTrustHtml(
            this.marcacaoAtual.relatorio_Profissional || ""
          );

        this.toastrService.info(
          "Última evolução desta especialidade carregada!",
          "Sucesso"
        );
      },

      error: (err) => {
        this.toastrService.error("Erro ao buscar evoluções.", "Erro");
        console.error(err);
      }
    });
  }

  ngOnDestroy() {    
    this.subscricoes.unsubscribe(); 
  }
}
